import { useEffect, useState } from "react";
import { TableShared } from "../../../../shared";
import { char, number } from "../../../../utils";
import { Message, useToaster } from "rsuite";
import { appCRUD } from "../../../../actions/app";
import moment from "moment";
import { AddCard } from "./add/addCard";

export const StudentCard = (props) => {
  const { dataId, student } = props;
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [index, setIndex] = useState(0);
  const toaster = useToaster();

  useEffect(() => {
    if(dataId){
      setLoading(true);
      setTimeout(() => {
        appCRUD
          .loadStudentCard(postsPerPage, nextPage, dataId, value, "id")
          .then((resp) => {
            setData(resp.data.results);
            setCount(resp.data.count);
          })
          .catch((error) => {
            toaster.push(
              <Message type="error" showIcon header={"Error"} closable>
                <p className="h6">
                  <p className="fw-bold fs-14">Oooh Sorry...!</p>
                  <p className="text-dark fs-12">{error}.</p>
                </p>
              </Message>,
              { placement: "topEnd", duration: 7000 }
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    }
  }, [page, postsPerPage, value, index, nextPage, dataId]);

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 60,
    },
    {
      key: "academic",
      title: "Academic Year",
      dataIndex: "academic",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "study",
      title: "Study Year",
      dataIndex: "study",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "issue",
      title: "Issue Date",
      dataIndex: "issue",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "expire",
      title: "Expire Date",
      dataIndex: "expire",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      sortable: true,
      flexGrow: 1,
    },
  ];
  

  const dataItem = data?.map((dt, i) => ({
    id: dt.id,
    sn: i + 1,
    academic: dt.academic_year ? dt.academic_year.name : "N/A",
    study: dt.study_year
      ? (() => {
          switch (dt.study_year.study_year) {
            case 1:
              return "First Year";
            case 2:
              return "Second Year";
            case 3:
              return "Third Year";
            case 4:
              return "Fourth Year";
            case 5:
              return "Fifth Year";
            case 6:
              return "Sixth Year";
            default:
              return "N/A";
          }
        })()
      : "N/A",
    issue: dt.issue_date
      ? moment(dt.issue_date).format("ddd. DD MMM YYYY")
      : "N/A",
    expire: dt.expiry_date
      ? moment(dt.expiry_date).format("ddd. DD MMM YYYY")
      : "N/A",
    status: dt.is_active ? (
      <span class="badge badge-soft-success badge-border fs-11">
        {char.toTitleCase("active")}
      </span>
    ) : (
      <span class="badge badge-soft-danger badge-border fs-11">
        {char.toTitleCase("inactive")}
      </span>
    ),
  }));
  
  

  const button = (
    <button className="btn btn-primary" onClick={() => setOpen(true)}>
      <span className="bi bi-plus-circle la-lg"></span> &nbsp; New Card
    </button>
  );

  return (
    <>
      <AddCard
        open={open}
        setOpen={setOpen}
        data={student}
        index={index}
        setIndex={setIndex}
      />
      <TableShared
        setOpen={null}
        loading={loading}
        data={dataItem}
        setData={setData}
        page={page}
        setPage={setPage}
        count={count}
        postsPerPage={postsPerPage}
        setePostPerPage={setePostPerPage}
        setNextPage={setNextPage}
        value={value}
        setValue={setValue}
        defaultColumns={defaultColumns}
        button={student?.is_verified && button}
        link={"#"}
        showButton={true}
        setLoading={setLoading}
      />
    </>
  );
};
